<template>
  <div>
    <el-table :data="tableData" highlight-current-row style="width: 100%">
      <el-table-column property="propValue" :label="item.propertyChooseTitle" width="200">
        <template slot-scope="{ row }">
          <el-select v-model="row.vid">
            <el-option
              v-for="op in item.values"
              :key="op.vid"
              :value="op.vid"
              :label="op.value"
              :disabled="tableData.some(item => item.vid === op.vid)"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column property="numberInputValue" :label="item.numberInputTitle" width="150">
        <template slot-scope="{ row }">
          <el-input-digit
            v-model.number="row.numberInputValue"
            placeholder="请输入"
            :max="Number(item.maxValue) || 100"
            format="#.##"
            style="width: 120px"
          >
            <span>%</span>
          </el-input-digit>
        </template>
      </el-table-column>
      <el-table-column property="opreate" label="操作" width="120">
        <template slot-scope="{ $index }">
          <el-link @click="deleteItem($index)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div><el-link @click="addItem">+ 添加</el-link></div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  watch: {
    item: {
      handler(v) {
        this.tableData = JSON.parse(JSON.stringify(this.value || []));
      },
      immediate: true,
    },
    tableData: {
      handler(v) {
        const opts = this.item.values || [];
        const list = JSON.parse(JSON.stringify(v || [])).filter(row => {
          if (row.vid && row.numberInputValue) {
            const findItem = opts.find(op => op.vid === row.vid) || {};
            row.propValue = findItem.value;
            console.log(row, '-----item.propValue && item.numberInputValue--');
            return true;
          }
        });
        this.$emit('change', list);
      },
      deep: true,
    },
  },
  methods: {
    addItem() {
      this.tableData.push({
        refPid: this.item.refPid,
        templatePid: this.item.templatePid,
        pid: this.item.pid,
        propName: this.item.name,
        numberInputValue: '',
        propValue: '',
        valueExtendInfo: '',
        valueUnit: '%',
        vid: '',
      });
    },
    deleteItem(index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.input-number {
  .el-input__inner {
    text-align: left;
  }
}
</style>